import ProfileTabPartial from "../../partials/account/profile-tab.partial";
export default function ProfileScreen() {
  return <ProfileTabPartial />;
}
